import React, { useEffect, useState } from 'react';
import { Vehiculo } from '../../../../../infraestructure/persistence/rest/VehiculosAdapter';
import SelectorSimple from '../../../../../shared/Components/Selectores/Simple';


export const SelectorVehiculos = (props:any) =>{

  let {data, onChange, valueOfSelected} = props;
  let [options, setOptions] = useState<any>(undefined)

  useEffect(()=>{
    if(data)
    {setOptions(getOptions())}
  },[data])

  useEffect(()=>{
    if(valueOfSelected===undefined && options!==undefined){ change(options[0]&&options[0].value)}
  },[options&&options.length])
  
  const getOptions = () =>{
    return data.map((v: Vehiculo)=> { return { value: v.vehiculo, inputDisplay: v.vehiculo } })
  }

  const change = (value:any) =>{
    onChange(value)
  }

  return (
    <SelectorSimple {...props} options={options} onChange={change} name="selectVehiculos"/>
  )
}
export default SelectorVehiculos